import React from 'react';
import ListTemplate from '../../../Reusable_Components/ListTemplate';
import { API_ROUTES, API_DOMAIN } from '../../../Reusable_Components/Config/apiConfig';

const AccessControlList = () => {
  const columns = [
    { label: 'User', value: 'user' },
    { label: 'Role', value: 'role' },
    { label: 'Can View Reports', value: (item) => item.can_view_reports ? 'Yes' : 'No' },
    { label: 'Can Edit Transactions', value: (item) => item.can_edit_transactions ? 'Yes' : 'No' },
    { label: 'Can Approve Payments', value: (item) => item.can_approve_payments ? 'Yes' : 'No' },
    { label: 'Access Details', value: (id) => <button onClick={() => handleAccessDetails(id)}>Access Details</button> },
  ];

  const handleAccessDetails = (id) => {
    const encodedId = btoa(id);
    window.location.href = '/security/access-control/details/' + encodedId;
  };
  return <ListTemplate columns={columns} onAccessDetails={handleAccessDetails} fetchUrl={API_DOMAIN + API_ROUTES['accessControl']} />;
};

export default AccessControlList;